export const getYoutubeID = url => {
  const queryString = url.split('?')[1];

  return new URLSearchParams(queryString).get('v');
};
